<header class="header-SSBA">
  <app-health-pillar/>

  <app-banner
    [screenSize]="screenSize()"
    [user]="userService.user()"
    [activeFacility]="userService.activeFacility()"
    (logout)="authService.logout()"
    (chooseFacility)="userService.openFacilityDialog()"
  />

  <!-- Navigation -->
  <app-nav/>
</header>
